export default "__VITE_ASSET__CyNhaD7___"